export const RoleType={
    Admin:'Admin',
    Coach:'Coach',
    User:'User',
    FreeTrail:'FreeTrailUser'
}